import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { useDispatch, useSelector } from "react-redux";
import {
  getFaqDetails,
  updateFaq,
  clearErrors,
} from "../../../actions/faqActions";
import { FAQ_UPDATE_RESET } from "../../../constants/faqConstants";

import Loader from "../../Loader";

const EditFaq = ({ match, history }) => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [faq, setFaq] = useState({
    question: "",
    answer: "",
    status: false,
  });
  const [errorData, setErrorData] = useState({});

  const { question, answer, status } = faq;

  const { loading, success, error, errors } = useSelector(
    (state) => state.updateFaq
  );

  const {
    loading: loadingDetails,
    error: errorDetails,
    faq: loadedFaq,
  } = useSelector((state) => state.faqDetails);

  // First useEffect to handle data fetching - runs only once on component mount
  useEffect(() => {
    // Only fetch data if we haven't already
    if (!isDataFetched) {
      console.log("Fetching FAQ data for ID:", match.params.id);
      dispatch(getFaqDetails(match.params.id));
      setIsDataFetched(true);
    }
  }, [dispatch, match.params.id, isDataFetched]);

  // Second useEffect to handle data updates and form state
  useEffect(() => {
    if (errors) {
      setErrorData(errors);
    }

    if (error) {
      clearErrors();
      return alert.error(error);
    }

    if (errorDetails) {
      clearErrors();
      return alert.error(errorDetails);
    }

    // Update form state when loadedFaq data is available
    if (loadedFaq && loadedFaq._id) {
      console.log("Setting form data from loaded FAQ:", loadedFaq);
      setFaq({
        question: loadedFaq.question,
        answer: loadedFaq.answer,
        status: loadedFaq.status,
      });
    }

    if (success === true && success !== undefined) {
      alert.success("FAQ was successfully updated.");
      dispatch({
        type: FAQ_UPDATE_RESET,
      });
      history.push("/admin/faqs");
      clearErrors();
    }
  }, [
    dispatch,
    error,
    errorDetails,
    loadedFaq,
    success,
    errors,
    alert,
    history,
  ]);

  const onChange = (e) => {
    if (e.target.name === "status") {
      setFaq({
        ...faq,
        status: !status,
      });
    } else {
      setFaq({
        ...faq,
        [e.target.name]: e.target.value,
      });
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("Submitting FAQ update:", { question, answer, status });
    dispatch(updateFaq(loadedFaq._id, { question, answer, status }));
  };

  return (
    <Fragment>
      {loading || loadingDetails ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Edit
                <small>FAQ</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/admin/faqs">
                    <i className="fa fa-table"></i> FAQs
                  </Link>
                </li>
                <li className="active">Edit FAQ</li>
              </ol>
            </section>

            <section className="content">
              <div className="box box-default">
                <div className="box-header with-border">
                  <h3 className="box-title">Edit FAQ</h3>
                </div>

                <form id="quickForm" onSubmit={submitHandler}>
                  <div className="box-body">
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="question">Question</label>
                        <input
                          type="text"
                          name="question"
                          className="form-control"
                          id="question"
                          placeholder="Enter the FAQ question"
                          value={question}
                          onChange={onChange}
                        />
                        {errorData.question ? (
                          <span className="text-danger">
                            {errorData.question}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <label htmlFor="answer">Answer</label>
                        <textarea
                          name="answer"
                          className="form-control"
                          id="answer"
                          rows="6"
                          placeholder="Enter the FAQ answer"
                          value={answer}
                          onChange={onChange}
                        ></textarea>
                        {errorData.answer ? (
                          <span className="text-danger">
                            {errorData.answer}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-6">
                        <label htmlFor="status">Status</label>
                        <input
                          style={{ marginRight: "5px" }}
                          type="checkbox"
                          className="form-check-input"
                          id="status"
                          name="status"
                          checked={status}
                          value={status}
                          onChange={onChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="box-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EditFaq;
